import { Button as ButtonPrimitive } from "@base-ui/react/button"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "group/button inline-flex shrink-0 cursor-pointer items-center justify-center rounded-lg border border-transparent bg-clip-padding text-sm font-medium whitespace-nowrap transition-all outline-none select-none focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 active:not-aria-[haspopup]:translate-y-px disabled:pointer-events-none disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
  {
    variants: {
      variant: {
        /** Применить / основной CTA — жёлтый */
        default: "bg-primary text-primary-foreground hover:bg-primary/85",
        accent: "bg-accent text-accent-foreground hover:bg-accent/90",
        /** Отменить / вторичное */
        outline:
          "border-border bg-background hover:border-accent hover:bg-accent/25 hover:text-accent-foreground",
        secondary:
          "bg-secondary text-secondary-foreground hover:bg-accent/30 hover:text-accent-foreground",
        ghost: "hover:bg-accent/30 hover:text-accent-foreground",
        /** Сохранить / успех */
        success:
          "bg-success text-success-foreground hover:bg-success/90 focus-visible:ring-success/40",
        /** Предупреждение / сброс с риском */
        warning:
          "bg-warning text-warning-foreground hover:bg-warning/90 focus-visible:ring-warning/40",
        /** Инфо / скачать / справка */
        info: "bg-info text-info-foreground hover:bg-info/90 focus-visible:ring-info/40",
        /** Удалить */
        destructive:
          "bg-destructive text-destructive-foreground hover:bg-destructive/90 focus-visible:ring-destructive/40",
        link: "text-foreground underline-offset-4 hover:text-accent-foreground hover:underline",
      },
      size: {
        default: "h-8 gap-1.5 px-2.5",
        sm: "h-7 gap-1 rounded-[min(var(--radius-md),12px)] px-2.5 text-[0.8rem]",
        lg: "h-10 gap-1.5 px-4 text-[0.9375rem]",
        icon: "size-8",
        "icon-sm": "size-7",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

function Button({
  className,
  variant = "default",
  size = "default",
  ...props
}: ButtonPrimitive.Props & VariantProps<typeof buttonVariants>) {
  return (
    <ButtonPrimitive
      data-slot="button"
      className={cn(buttonVariants({ variant, size, className }))}
      {...props}
    />
  )
}

export { Button, buttonVariants }
